import styled from 'styled-components';
export var StyledHeader = styled.div.withConfig({
  displayName: "StyledHeader",
  componentId: "sc-pukkw5-0"
})(["display:flex;flex-flow:column nowrap;gap:4px;padding:12px 20px;border-bottom:1px solid #eff0fa;"]);
export var StyledHeaderTitle = styled.div.withConfig({
  displayName: "StyledHeaderTitle",
  componentId: "sc-pukkw5-1"
})(["color:#191c1e;font-size:15px;font-weight:500;line-height:140%;"]);
export var StyledLabel = styled.span.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-pukkw5-2"
})(["color:#9c9fb4;font-size:12px;font-weight:400;line-height:140%;"]);
export var StyledValue = styled.span.withConfig({
  displayName: "StyledValue",
  componentId: "sc-pukkw5-3"
})(["color:#2c2842;font-size:12px;font-weight:400;line-height:140%;"]);
export var StyledHeaderRow = styled.div.withConfig({
  displayName: "StyledHeaderRow",
  componentId: "sc-pukkw5-4"
})(["display:flex;align-items:center;gap:4px;"]);
export var StyledHeaderValue = styled(StyledValue).withConfig({
  displayName: "StyledHeaderValue",
  componentId: "sc-pukkw5-5"
})(["color:#5a5d6d;"]);
export var StyledItemContainer = styled.div.withConfig({
  displayName: "StyledItemContainer",
  componentId: "sc-pukkw5-6"
})(["display:flex;flex-flow:column nowrap;gap:4px;padding:8px 20px;border-bottom:1px solid #eff0fa;background:#fff;"]);
export var StyledItemRow = styled.div.withConfig({
  displayName: "StyledItemRow",
  componentId: "sc-pukkw5-7"
})(["display:flex;justify-content:space-between;align-items:center;gap:4px;"]);
export var StyledDateLabel = styled.span.withConfig({
  displayName: "StyledDateLabel",
  componentId: "sc-pukkw5-8"
})(["color:#191c1e;font-size:14px;font-weight:500;line-height:140%;"]);
export var StyledStatusText = styled.div.withConfig({
  displayName: "StyledStatusText",
  componentId: "sc-pukkw5-9"
})(["color:", ";font-size:12px;font-weight:400;line-height:140%;"], _ref => {
  var color = _ref.color;
  return color !== null && color !== void 0 ? color : '#9C9FB4';
});
export var StyledIconLink = styled.img.withConfig({
  displayName: "StyledIconLink",
  componentId: "sc-pukkw5-10"
})(["width:16px;height:24px;"]);
export var StyledInsufficientText = styled.div.withConfig({
  displayName: "StyledInsufficientText",
  componentId: "sc-pukkw5-11"
})(["display:flex;padding:8px 12px;align-items:center;width:100%;border-radius:12px;border:1px solid #fd5939;background:#fdefef;color:#fd5939;font-size:12px;font-weight:400;line-height:16px;text-align:center;"]);
export var StyledTradesContainer = styled.div.withConfig({
  displayName: "StyledTradesContainer",
  componentId: "sc-pukkw5-12"
})(["max-height:363px;overflow-y:auto;"]);
export var StyledYearRow = styled.div.withConfig({
  displayName: "StyledYearRow",
  componentId: "sc-pukkw5-13"
})(["width:100%;height:28px;padding:0 20px;color:#8d93b5;background:#f5f7fb;font-size:12px;font-weight:400;line-height:28px;"]);